<div class="tw-flex tw-items-stretch">
  <div
    class="tw-relative tw-flex tw-w-10 tw-items-center tw-justify-center tw-border tw-border-cloud tw-p-0"
    [ngStyle]="{ 'background-color': formControl.value }"
  >
    <i class="bi bi-eyedropper"></i>
    <input
      type="color"
      aria-label="color"
      class="tw-absolute tw-h-full tw-w-full tw-cursor-pointer tw-opacity-0"
      [formControl]="formControl"
    />
  </div>
  <input
    aria-label="color"
    type="text"
    [value]="formControl.value"
    (change)="onChange($event)"
    class="hmm-input tw-flex-1 tw-rounded-s-none tw-border-s-0"
    [formlyAttributes]="field"
  />
</div>
